import { JitsiConferenceEvents } from '../base/lib-jitsi-meet';
import StateListenerRegistry from '../base/redux/StateListenerRegistry';
import { disableVTFileUploadModeration, enableVTFileUploadModeration, localParticipantApproved, localParticipantRejected, participantApproved, participantRejected, receiveSlot, receiveSlotError } from './slice';
/**
 * Registers a change handler for state['features/base/conference'].conference to
 * set the event listeners needed for the A/V moderation feature to operate.
 */
StateListenerRegistry.register((state) => state['features/base/conference'].conference, (conference, { dispatch }, previousConference) => {
    if (conference && !previousConference) {
        conference.on(JitsiConferenceEvents.VT_FILE_UPLOAD_MODERATION_CHANGED, ({ enabled, actor }) => {
            enabled ? dispatch(enableVTFileUploadModeration(actor)) : dispatch(disableVTFileUploadModeration(actor));
        });
        conference.on(JitsiConferenceEvents.VT_FILE_UPLOAD_MODERATION_APPROVED, ({ requestOccupantJid }) => {
            dispatch(localParticipantApproved());
        });
        conference.on(JitsiConferenceEvents.VT_FILE_UPLOAD_MODERATION_REJECTED, () => {
            dispatch(localParticipantRejected());
        });
        conference.on(JitsiConferenceEvents.VT_FILE_UPLOAD_MODERATION_PARTICIPANT_APPROVED, ({ participant }) => {
            const { _id: jid } = participant;
            dispatch(participantApproved({ jid }));
        });
        conference.on(JitsiConferenceEvents.VT_FILE_UPLOAD_MODERATION_PARTICIPANT_REJECTED, ({ participant }) => {
            const { _id: jid } = participant;
            dispatch(participantRejected({ jid }));
        });
        conference.on(JitsiConferenceEvents.VT_FILE_UPLOAD_SLOT_INFO, ({ slotInfo }) => {
            dispatch(receiveSlot(slotInfo));
        });
        conference.on(JitsiConferenceEvents.VT_FILE_UPLOAD_SLOT_ERROR, ({ error }) => {
            dispatch(receiveSlotError(error));
        });
    }
});
